// extracted by mini-css-extract-plugin
export default {"notFound":"NotFoundPage_notFound__nm9cL","text":"NotFoundPage_text__I1gJS"};